// extracted by mini-css-extract-plugin
module.exports = {"consumable-product-detail":"styles_consumable-product-detail__oDr5V"};